import { useEffect } from "react";
import { FileText } from "lucide-react";
import { api } from "@/lib/api";

const src = (url) => `${process.env.REACT_APP_BACKEND_URL}${url}`;

export function useTimeTracker(moduleId) {
  useEffect(() => {
    if (!moduleId) return undefined;
    const t = setInterval(() => {
      if (document.visibilityState === "visible") api.post("/track/time", { module_id: moduleId, seconds: 30 }).catch(() => {});
    }, 30000);
    return () => clearInterval(t);
  }, [moduleId]);
}

export default function ModuleMedia({ items }) {
  if (!items?.length) return null;
  return (
    <section className="reader-sec" data-testid="module-media">
      {items.map((f) => (
        <div key={f.id} style={{ marginBottom: "1.2rem" }} data-testid={`module-media-${f.id}`}>
          {f.kind === "video" && <video controls preload="metadata" src={src(f.url)} style={{ width: "100%", borderRadius: 14 }} />}
          {f.kind === "audio" && <><p style={{ fontWeight: 600, marginBottom: ".4rem" }}>{f.name}</p><audio controls preload="metadata" src={src(f.url)} style={{ width: "100%" }} /></>}
          {(f.kind === "pdf" || f.kind === "image") && (
            <a href={src(f.url)} target="_blank" rel="noreferrer" className="btn btn-ghost" data-testid={`module-media-open-${f.id}`}><FileText size={18} /> Abrir {f.name}</a>
          )}
        </div>
      ))}
    </section>
  );
}
